import {app} from "@/modules/app";
import {useStackRouteComponent} from "@/packages/stack-router/hooks/useStackRoute";

app.addRoutes([
    {
        parent: 'page',
        path: '/promotions',
        component: () => import("@/pages/offer/offers.vue"),
        meta: {
            title: 'Акции'
        }
    },
    {
        parent: 'public',
        path: '/offer/:id',
        component: useStackRouteComponent(() => import("@/pages/offer/offer.dialog.vue")),
        meta: {}
    },
    {
        parent: 'public',
        path: '/offer/:id/hide',
        component: useStackRouteComponent(() => import("@/pages/offer/offer-hide.dialog.vue")),
        meta: {}
    },
])

